import { Box, Typography, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ui } from "../i18n";
import { LayoutState, LayoutTextMarginTopSmall, MediaQueryLinebreak, MediaQueryMobile, MediaQueryShallow, MediaQuerySmall1, MediaQuerySmall2, MediaQuerySmall3, MediaQuerySmall4, MediaQuerySmall5, ScrollToPosition } from "../Layout";
import { change } from "../state/Nav";
import { RootState } from "../store";
import { TextBody, TextBox, TextHeader } from "../Styles";
import { hideKrpano } from "../Util";

export default function Artist() {
        // Init layout parameters
        const layoutState = new LayoutState();
        layoutState.isMobile = useMediaQuery(MediaQueryMobile);
        layoutState.isShallow = useMediaQuery(MediaQueryShallow);
        layoutState.linebreak = useMediaQuery(MediaQueryLinebreak);
        layoutState.isSmall1 = useMediaQuery(MediaQuerySmall1);
        layoutState.isSmall2 = useMediaQuery(MediaQuerySmall2);
        layoutState.isSmall3 = useMediaQuery(MediaQuerySmall3);
        layoutState.isSmall4 = useMediaQuery(MediaQuerySmall4);
        layoutState.isSmall5 = useMediaQuery(MediaQuerySmall5);

        // Determine UI language
        const lang = useSelector((state: RootState) => state.language.value);

        // Set navigation to current component
        const dispatch = useDispatch();
        dispatch(change("artist"));

        // Hide virtual tour
        hideKrpano();

        // Scroll to previous position
        ScrollToPosition("artist");

        return (
                <Box sx={{ paddingBottom: layoutState.LayoutPaddingBottom(), paddingTop: layoutState.paddingTop() }}>
                        <TextBox>
                                <TextHeader>
                                        {ui[lang].Artist.vita}
                                </TextHeader>
                                <TextBody marginTop={LayoutTextMarginTopSmall}>
                                        {ui[lang].Artist.vitabody}

                                </TextBody>
                                <img src={"/artist.png"} style={{ display: "block", maxWidth: "600px", width: layoutState.ArtistWidth(), height: "auto", margin: "auto", paddingTop: "20px" }} />
                                <Box component="div" sx={{ paddingTop: "10px", display: "flex", alignItems: "bottom", justifyContent: "center" }}>
                                        <Typography gutterBottom variant="subtitle1" >
                                                {ui[lang].Artist.vitacaption}
                                        </Typography>
                                </Box>
                        </TextBox>
                </Box>
        );
}